// Logos de paqueterías - Archivos locales en /public/logos/
export const CARRIER_LOGOS = {
  "FedEx": "/logos/fedex.svg",
  "DHL": "/logos/dhl.svg",
  "Estafeta": "/logos/estafeta.svg",
  "UPS": "/logos/ups.svg",
  "Redpack": "/logos/redpack.svg",
  "99 Minutos": "/logos/99minutos.svg",
  "Paquetexpress": "/logos/paquetexpress.svg",
  "J&T Express": "/logos/jtexpress.svg",
};

// Colores de marca de cada paquetería
export const CARRIER_COLORS = {
  "FedEx": "#4D148C",
  "DHL": "#D40511", 
  "Estafeta": "#E31937",
  "UPS": "#351C15",
  "Redpack": "#E31937",
  "99 Minutos": "#00D4AA",
  "Paquetexpress": "#0066B3",
  "J&T Express": "#FF6B35",
  "SENDEX": "#2563EB",
  "PUNTOPOST": "#059669",
  "Tres Guerras": "#7C3AED",
};

// Fallback: logos en base64 inline para cuando las URLs no funcionan
export const CARRIER_LOGOS_FALLBACK = {
  "FedEx": "FedEx",
  "DHL": "DHL",
  "Estafeta": "Estafeta",
  "UPS": "UPS",
  "Redpack": "Redpack",
  "99 Minutos": "99 Minutos",
  "Paquetexpress": "Paquetexpress",
};

// Componente de logo con fallback
export const CarrierLogo = ({ carrier, className = "", size = "normal" }) => {
  const logoUrl = CARRIER_LOGOS[carrier];
  const color = CARRIER_COLORS[carrier] || "#333";
  
  const sizeClasses = {
    small: "h-8",
    normal: "h-12",
    large: "h-16"
  };

  if (!logoUrl) {
    return (
      <span className={`font-bold text-lg ${className}`} style={{ color }}>
        {carrier}
      </span>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <img 
        src={logoUrl}
        alt={`Logo ${carrier}`}
        className={`${sizeClasses[size]} w-auto object-contain`}
        onError={(e) => {
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'block';
        }}
      />
      <span 
        className="font-bold text-lg hidden"
        style={{ color }}
      >
        {carrier}
      </span>
    </div>
  );
};

export default CarrierLogo;
